<template>
  <v-container>
    <p class="text-left text-h4 font-weight-bold">
      <span>
        <strong><span>注意須知</span></strong>
        </span
      >
    </p>
    <p style="color:#646cba; font-size: 1.5rem; font-weight: 600">
      ■&nbsp;關於繳費
    </p>
    <p style="margin-bottom: 12px">
      一、場地提供多元支付方式，請您留意是否申請遠通月票代扣服務，<span style="color: #ff0000">系統會依照遠通代扣優先執行扣款</span>。其他支付方式規則請參下方表格：
      <table
          class="mt-3 rounded-corners"
          style="width: 100%;"
        >
          <caption style="text-align: left; font-size: 14px; caption-side: bottom;">※ 如繳費單金額大於單筆限額，則不提供該支付方式</caption>
          <tr>
            <td class="pa-3">
              <div style="display:flex; margin-bottom: 8px;"><div style="width: 100%;"><span style="font-size: 1.2rem; font-weight: 500">iPASS MONEY</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">付款流程</span><div style="width: 100%;"><span>綁定錢包、銀行帳戶（不開放信用卡），線上付款</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">單筆限額</span><div style="width: 100%;"><span>NT$50,000</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">繳費區間</span><div style="width: 100%;"><span>每月20號～當月月底晚上十點</span></div></div>
            </td>
          </tr>
          <tr>
            <td class="pa-3">
              <div style="display:flex; margin-bottom: 8px;"><div style="width: 100%;"><span style="font-size: 1.2rem; font-weight: 500">超商代收</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">付款流程</span><div style="width: 100%;"><span>產出超商條碼，臨櫃繳費</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">單筆限額</span><div style="width: 100%;"><span>NT$20,000</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">繳費區間</span><div style="width: 100%;"><span>每月20號～<span style="color: #ff0000">當月月底前三天</span></span></div></div>
            </td>
          </tr>
           <tr>
            <td class="pa-3">
              <div style="display:flex; margin-bottom: 8px;"><div style="width: 100%;"><span style="font-size: 1.2rem; font-weight: 500">悠遊付</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">付款流程</span><div style="width: 100%;"><span>綁定錢包、銀行帳戶（不開放信用卡），線上付款</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">單筆限額</span><div style="width: 100%;"><span>NT$12,000</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">繳費區間</span><div style="width: 100%;"><span>每月20號～當月月底晚上十點</span></div></div>
            </td>
          </tr>
          <tr>
            <td class="pa-3">
              <div style="display:flex; margin-bottom: 8px;"><div style="width: 100%;"><span style="font-size: 1.2rem; font-weight: 500">信用卡</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">付款流程</span><div style="width: 100%;"><span>輸入卡號完成線上付款</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">單筆限額</span><div style="width: 100%;"><span>依發卡銀行信用卡額度而定</span></div></div>
              <div style="display:flex"><span style="width: 120px; color: #999999">繳費區間</span><div style="width: 100%;"><span>每月20號～當月月底晚上十點</span></div></div>
            </td>
          </tr>

        </table>
    </p>
    <p style="margin-bottom: 12px">
      二、為避免重複扣款或交易錯誤，若單筆繳費單未完成線上付款流程，20分鐘內將無法嘗試其他支付方式。
    </p>
    <p style="margin-bottom: 12px">
      三、於外部網頁或 App <span style="color: #ff0000">完成付款後，請您耐心等候導轉回本網頁查看繳費結果</span>。未完成上述流程前，請勿進行以下操作，以免影響繳費結果：
      <ul>
        <li>關閉本網頁（月票繳費服務平台）</li>
        <li>關閉手機畫面</li>
      </ul>
    </p>
    <p style="margin-bottom: 12px">
      四、<span style="color: #ff0000">如繳費結果為「付款確認中」，請您於5分鐘後再重試付款流程</span>。
    </p>
    <p style="margin-bottom: 12px">
      五、當發生溢繳或繳費後要退租時，請聯絡該場管理人員。
    </p>
    <p style="color:#646cba; margin-top: 40px; font-size: 1.5rem; font-weight: 600">
      ■&nbsp;關於發票
    </p>
    <p style="margin-bottom: 12px">
      一、發票資訊有誤<span style="color: #ff0000">須『作廢』或『折讓』重開，請於次月五號前（含）提出，遇假日不順延</span>，逾期則無法再協助重開發票，並自公告日起實施。
    </p>
    <p>
      二、<span style="color: #ff0000">發票一經開立，恕無法換開為載有公司統一編號的電子發票</span>，請於繳費時確認應取得無統編（個人消費）或有統編（公司報帳用）發票，本公司有權利考量各因素後拒絕換開發票。
    </p>
    <p style="margin-top: 40px">※ 若您接到任何可疑電話，聲稱有優惠活動、帳務問題，請直接聯繫停車場管理人員求證，切勿提供個人資料或依照指示操作。</p>
    <v-divider class="mt-2 mb-2"></v-divider>
    <p class="text-left text-h4 font-weight-bold mt-5">
      <span>
        <strong><span>繳費列表</span></strong>
        </span>
    </p>
    <v-row v-if="showTable">
      <v-col col="12">
        <table
          v-for="(item, key) in rentSetList"
          :key="key"
          class="mb-9 rounded-corners"
          style="width: 100%;"
        >
          <tr>
            <td
              v-if="rentSetList.length > 1"
              colspan="2"
              class="pa-2"
              style="text-align: center"
            >
              <span style="color:#646cba; font-size: 1.5rem; font-weight: 500">序號: {{ key + 1 }}</span>
            </td>
          </tr>
          <tr>
            <td width="50%" class="pa-2">
              <span class="text-h6">場地</span><br /><span
                class="text-subtitle-1"
                >{{ item.RentPay_SiteName }}</span
              >
            </td>
            <td class="pa-2">
              <span class="text-h6">連絡電話</span><br /><span
                class="text-subtitle-1"
                >{{ item.RentPay_SiteTel }}</span
              >
            </td>
          </tr>
          <tr class="frame-line">
            <td class="pa-2">
              <span class="text-h6">租戶名稱</span><br /><span
                class="text-subtitle-1"
                >{{ item.RentPay_RentName }}</span
              >
            </td>
            <td class="pa-2">
              <span class="text-h6">車號</span><br /><span
                class="text-subtitle-1"
                >{{
                  item.RentPay_CarNo === '無限制' ? '' : item.RentPay_CarNo
                }}</span
              >
            </td>
          </tr>
          <tr class="frame-line">
            <td class="pa-2">
              <span class="text-h6">繳費租期</span><br /><span
                class="text-subtitle-1"
                >{{ item.RentPay_RentDateRange }}</span
              >
            </td>
            <td colspan="2" class="pa-2">
              <canvas width="100%" height="80" :id="'priceCanvas_' + key" />
            </td>
          </tr>
          <tr class="frame-line">
            <td colspan="2" class="pa-2">
              <v-radio-group v-model="item.SelectedPayMethod" row>
                <v-radio
                  v-for="payMethod in item.RentPay_PayMethods"
                  :key="payMethod.PayMethod_PayMode"
                  :value="payMethod"
                  style="height:40px;width: 150px;"
                >
                  <template v-slot:label>
                    <img
                      v-if="payMethod.PayMethod_PayMode == 52"
                      :src="require('../assets/EasyWallet.png')"
                      height="35"
                    />
                    <img
                      v-else-if="payMethod.PayMethod_PayMode == 60"
                      :src="require('../assets/ICashPay.png')"
                      width="100"
                    />
                    <img
                      v-else-if="payMethod.PayMethod_PayMode == 62"
                      :src="require('../assets/iPASSMONEY.svg')"
                      width="100"
                    />
                    <div
                      v-else-if="payMethod.PayMethod_PayMode == 31"
                      style="display: flex;width:120px;align-items: center;"
                      >
                      <img
                      :src="require('../assets/Store_V.svg')"
                      width="24"
                      height="24"
                      style="display: block;"
                      />
                      <p style="font-size: 20px; padding-left: 3px;margin: 0;">超商代收</p>
                    </div>
                    <div
                      v-else-if="payMethod.PayMethod_PayMode == 63"
                      style="display: flex;width:120px;align-items: center;"
                      >
                      <img
                        :src="require('../assets/s-creditCard.svg')"
                        width="24"
                      />
                      <span style="font-size: 20px; padding-left: 8px;margin: 0;" >信用卡</span>
                    </div>
                    <span v-else style="font-size: 20px">{{
                      payMethod.PayMethod_Name
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </td>
          </tr>
          <tr class="frame-line">
            <td
              v-if="item.RentPay_PayMethods.length > 0"
              colspan="2"
              class="pa-2"
            >
              <v-btn
                block
                depressed
                :color="item.btnColor ? item.btnColor : 'primary'"
                @click="goPayment(item, key)"
              >
                付款
              </v-btn>
            </td>
            <td
              v-else
              colspan="2"
              class="pa-2"
              style="color: red; text-align: center"
            >
              <span>該場地未開啟線上付款, 請聯繫現場管理員</span>
            </td>
          </tr>
        </table>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogBarCode"
      transition="dialog-bottom-transition"
      fullscreen
    >
      <v-card >
        <v-toolbar dark color="primary">
          <v-toolbar-title>繳費條碼</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="dialogBarCode = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="start" class="mt-3">
            <table class="rounded-corners" style="width: 60%">
              <tbody v-if="autoWithhold.AutoWithhold_State < 9">
                <tr>
                  <td colspan="2" class="pa-1 text-center text-h6">
                    <span class="text-h6">序號</span><br /><span
                      class="text-subtitle-1"
                      >{{ autoWithhold.SeqNo }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="pa-1 text-center text-h6">
                    <span class="text-h6">場地</span><br /><span
                      class="text-subtitle-1"
                      >{{ autoWithhold.SiteName }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="pa-1 text-center text-h6">
                    <span class="text-h6">繳費租期</span><br /><span
                      class="text-subtitle-1"
                      >{{ autoWithhold.RentDateRange }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="pa-1 text-center text-h6">
                    超商專用條碼區
                    <br />
                    <div class="d-flex flex-row justify-center">
                      <v-img
                        src="../assets/LOGO_7-11.png"
                        max-height="100"
                        max-width="40"
                      ></v-img>
                      <v-img
                        src="../assets/LOGO_OK.png"
                        max-height="100"
                        max-width="40"
                      ></v-img>
                      <v-img
                        src="../assets/LOGO_Family.png"
                        max-height="100"
                        max-width="40"
                      ></v-img>
                      <v-img
                        src="../assets/LOGO_Life.png"
                        max-height="100"
                        max-width="40"
                      ></v-img>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="pa-2 text-center">
                    <span
                      v-for="(
                        barItem, barKey
                      ) in autoWithhold.AutoWithhold_BarCode.split(',')"
                      :key="barKey"
                    >
                      <vue-barcode
                        :value="barItem"
                        :width="barcodeOpts.width"
                        :height="barcodeOpts.height"
                        :format="barcodeOpts.format"
                      />
                      <br />
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="pa-2 red--text text-h5">
                    繳費單產生失敗，原因 : {{ autoWithhold.Model_ErrorMsg }}
                  </td>
                </tr>
              </tbody>
            </table>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 富邦信用卡 -->
    <v-dialog
      v-model="dialogFubonCard"
      transition="dialog-bottom-transition"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>信用卡</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="handleCloseDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="start" class="mt-2">
            <v-form ref="isFubonFormValid" v-model="isFubonFormValid" @submit.prevent="submitFubonCard()">
              <v-container>
                <v-col cols="12" sm="12" md="12" justify="start" class="d-flex pa-0">
                  可使用卡別
                  <v-img
                    src="../assets/creditCard.svg"
                    max-height="30"
                    max-width="80"
                    contain
                  ></v-img>
                </v-col> 
                <v-row justify="start" class="pt-2 py-0">
                  <v-col cols="12" sm="12" md="12" class="py-0 pt-3">
                    <v-text-field 
                      type="tel"
                      v-model="setFubonCardModel.cardNo" 
                      label="信用卡號" 
                      hint="請輸入 16 位卡號"
                      persistent-hint
                      placeholder="0000 0000 0000 0000"
                      maxlength="19"
                      inputmode="numeric"
                      validate-on-blur
                      :rules="cardNoRules"
                      pattern="[0-9]*"
                      @input="formatCardNumber"
                      outlined
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row justify="start">
                  <v-col cols="7"  class="py-0 pt-2">
                    <v-text-field
                    hide-details="auto"
                      ref="expiryInput"
                      type="tel"
                      v-model="setFubonCardModel.expiryDate"
                      label="有效期 (MM/YY)"
                      placeholder="MM / YY"
                      hint="格式範例：05 / 35"
                      persistent-hint
                      maxlength="7"
                      validate-on-blur
                      inputmode="numeric"
                      :rules="expiryRules"
                      @input="formatExpiry"
                      outlined
                  ></v-text-field>
                  </v-col>

                  <v-col cols="5" class="py-0 pt-2">
                    <v-text-field 
                      type="tel"
                      v-model="setFubonCardModel.CVV" 
                      label="安全碼"
                      maxlength="3"
                      hint="簽名欄旁3碼"
                      persistent-hint
                      inputmode="numeric"
                      @input="validateCVV"
                      required
                      :rules="[
                          v => !v || v.length >= 3 || true, // 當長度小於 3 時回傳 true (隱藏錯誤)
                          v => (v && v.length === 3) || '請輸入安全碼'
                      ]"
                      validate-on-blur
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <div class="mt-8">
                  <p
                    class="text-caption mb-1 text-center"
                    >
                    請確認所有卡號資訊都填寫正確
                  </p>
                  <v-btn
                    class="mt-4"
                    :disabled="!isDataComplete"
                    block
                    color="primary"
                    elevation="5"
                    type="submit"
                  >
                  確認繳費
                  </v-btn>
                </div>

                <v-row cols="12" class="mx-0 mt-5">
                  <div>
                    <div class="d-flex align-center mb-3">
                      <v-icon small class="mr-1">mdi-alert-circle-outline</v-icon>
                      <span class="font-weight-bold">小提醒</span>
                    </div>
                    <v-alert type="error" dense text class="mb-2 pa-3 text-caption" color="red darken-3" :icon="false">
                      1.不支援以下主流銀行：004-台灣銀行、017-兆豐國際商業銀行、806-元大商業銀行
                    </v-alert>
                    <v-alert type="info" dense text class="mb-2 pa-3 text-caption" :icon="false" color="grey darken-1">
                      2.目前可交易之信用卡﹕005-土地銀行、006-合作金庫、007-第一商業銀行、008-華南銀行、009-彰化銀行、011-上海商業儲蓄銀行、012-台北富邦、013-國泰世華銀行、016-高雄銀行、048-王道商業銀行、050-臺灣中小企業銀行、052-渣打國際商業銀行、053-台中商業銀行、081-匯豐（台灣）商業銀行、102-華泰商業銀行、108-陽信商業銀行、700-中華郵政股份有限公司、803-聯邦商業銀行、805-遠東國際商業銀行、807-永豐商業銀行、808-玉山銀行、809-凱基商業銀行、810-星展（台灣）商業銀行、812-台新國際商業銀行、816-安泰商業銀行、822-中國信託商業銀行
                    </v-alert>
                    <v-alert type="info" dense text class="mb-2 pa-3 text-caption" :icon="false" color="grey darken-1">
                      3.該繳費稅非一般交易，紅利、現金回饋請洽各發卡行。
                    </v-alert>
                  </div>
                </v-row>
              </v-container>
            </v-form>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>注意需知</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="mt-3">
            <span style="color: red; font-weight: bold"
              >一、選擇以悠遊付繳費月票費，限額每筆新臺幣1萬2千元(含)以下，僅開放綁定悠遊付錢包或銀行帳戶進行付款，不開放信用卡。</span
            >
          </div>
          <div class="mt-1">
            二、繳費場地在設定開放時間內才能查詢到超商繳費條碼。
          </div>
          <div class="mt-1">
            三、個人戶依車牌號碼公司戶依統一編號查詢後顯示超商條碼，請確認停放場地、繳費金額、繳費租期是否正確，如內容有誤請洽該場管理人員。
          </div>
          <div class="mt-1">
            四、場地提供多元繳費方式，請月票戶留意是否同時申請其它代扣月票費用服務，以避免發生溢繳狀況，如有發生敘述狀況請聯絡該場管理人員協助後續處理。
          </div>
          <div class="mt-1">
            五、超商代收後需１～２個工作天才會收到繳費完成通知，避免您的車輛進出逾期，請在繳費開放時間內完成月票繳費，紙本發票由該場公告索取方式執行。
          </div>
          <div class="mt-1">
            六、如發生溢繳或退租退費時，請聯絡該場管理人員申辦處理。
          </div>
          <div class="mt-1">
            七、為防止租戶接受到電話詐騙，如接到不明來電電話時，告知各種優惠活動、帳務溢繳或短收相關問題時，請租戶聯絡該場管理人員確認資訊是否正確。
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
table.rounded-corners {
  border: 1px solid #999;
  border-spacing: 0;
  /*border-collapse: collapse;*/
  border-collapse: separate;
  border-radius:8px;
}

table.rounded-corners th:not(:last-child),
table.rounded-corners td:not(:last-child) {
 border-right: 1px solid #999;
}

/* Apply a border to the bottom of all but the last row */
table.rounded-corners>thead>tr:not(:last-child)>th,
table.rounded-corners>thead>tr:not(:last-child)>td,
table.rounded-corners>tbody>tr:not(:last-child)>th,
table.rounded-corners>tbody>tr:not(:last-child)>td,
table.rounded-corners>tfoot>tr:not(:last-child)>th,
table.rounded-corners>tfoot>tr:not(:last-child)>td,
table.rounded-corners>tr:not(:last-child)>td,
table.rounded-corners>tr:not(:last-child)>th,
table.rounded-corners>thead:not(:last-child),
table.rounded-corners>tbody:not(:last-child),
table.rounded-corners>tfoot:not(:last-child) {
 border-bottom: 1px solid #999;
}

/*富邦信用卡輸入框錯誤提示  */
::v-deep .v-text-field__details {
  padding-left: 0 !important;
}
</style>

<script>
import VueBarcode from 'vue-barcode';
import { CompactEncrypt, importSPKI,} from 'jose';
export default {
  name: 'Charging',
  components: {
    VueBarcode,
  },
  data: () => ({
    showTable: false,
    barcodeOpts: {
      width: 1,
      height: 50,
      format: 'CODE39',
    },
    rentSetList: [],
    dialog: false,
    dialogBarCode: false,
    isExpiryFocused: false,
    dialogFubonCard: false,
    request_CreateOrder: {},
    autoWithhold: {},
    time: null,
    isFubonFormValid:false,
    prevExpiryLen: 0,
    isResetting: false,
    setFubonCardModel: {
      cardNo:'',
      expiryDate: '',
      CVV:'',
    },
    cardNoRules: [
      v => !!v || '請輸入有效的信用卡號',
      v => (v && v.replace(/\s/g, '').length === 16) || '請輸入正確的 16 碼卡號'
    ],
    cryptoConfig: null,
  }),
  computed: {
    /**
     * 富邦信用卡 UI 驗證機制
     * 
     * 1. 報錯機制 (視覺)：採「完全非即時」策略
     *    - 觸發點：僅限離開 (Blur) 事件。
     *    - 行為：輸入中(不論是否填滿長度或資料過期)皆不報錯，避免過早干擾。
     * 
     * 2. 安全監控 (邏輯)：isDataComplete (Computed 全時監控)
     *    - 狀態：即便視覺上沒報錯，後台仍隨時監測長度與過期。
     *    - 效果：只要資料未達標(16/4/3碼)或過期，提交按鈕必為 Disabled。
     * 
     * 3. 已知取捨 (UX Edge Case)：
     *    - 若最後填效期且過期，未移出焦點前會出現「按鈕禁點但無紅字」。
     *    - 結論：此為預期內的折衷，確保使用者在 Focus 時有安靜的輸入空間。
     */
    isDataComplete() {
      //正在重置中(關掉彈窗)直接終止
      if (this.isResetting) return false;

      // 物件存在性檢查：防止 null 物件解構報錯
      if (!this.setFubonCardModel) return false;

      // 欄位完整性檢查：確保業務必填欄位都有值
      const { cardNo, expiryDate, CVV } = this.setFubonCardModel;
      if (!cardNo || !expiryDate || !CVV) return false;

      // 1. 檢查卡號：格式化(已移除非數字字元)後是否為 16 位
      const isCardValid = cardNo.replace(/\D/g, '').length === 16;
      
      // 2. 檢查 CVV：是否為 3 位
      const isCvvValid = CVV.length === 3;

      // 3. 檢查有效日期
      const expiryStatus = this.checkExpiryStatus(expiryDate);

      return isCardValid && expiryStatus.valid && isCvvValid;
    },
    expiryRules() {
      return [
        v => !!v || '請輸入有效日期',
        v => this.checkExpiryStatus(v).valid || this.checkExpiryStatus(v).msg
      ];
    }
  },
  created() {
    // 強制打開 20240711 不跳視窗
    //this.dialog = true;
    const body = document.body;
    body.addEventListener(
      'touchstart',
      () => {
        this.time = new Date().getTime();
      },
      false
    );
    body.addEventListener(
      'touchmove',
      () => {
        this.time = new Date().getTime();
      },
      false
    );
    body.addEventListener(
      'mouseover',
      () => {
        this.time = new Date().getTime();
      },
      false
    );

    this.search();
  },
  updated() {
    this.rentSetList.forEach((item, index) => {
      // 繪製金額
      const priceCanvas = document.getElementById('priceCanvas_' + index);
      if (priceCanvas !== null) {
        const priceContent = priceCanvas.getContext('2d');
        priceContent.font = '20px Arial';
        priceContent.fillText('繳費金額', 0, 35);
        priceContent.fillText(
          '$' + this.$options.filters.toThousandFilter(item.RentPay_Amount),
          0,
          65
        );
      }
    });
  },
  methods: {
    search() {
      this.dbio('/RentPay/GetRent', {}).then((response) => {
        this.rentSetList = response;
        this.showTable = true;

        if (this.rentSetList.length == 0) {
          this.msg('查無繳費資訊', 2000);
        } else {
          this.rentSetList.forEach((x) => {
            x.btnColor = 'primary';
          });
          setTimeout(this.refresh, 5 * 60 * 500);
        }
      });
    },
    refresh() {
      // 差距超過30分鐘 重新整理
      if (new Date().getTime() - this.time >= 30 * 60 * 1000)
        window.location.reload();
      else setTimeout(this.refresh, 5 * 60 * 1000);
    },
    checkUniformNo(uniformNo) {
      if (uniformNo && uniformNo.length === 8) {
        const overTen = function (value) {
          while (value >= 10) {
            value = Math.floor(value / 10) + (value % 10);
          }

          return value;
        };

        let intTmpSum = 0;

        for (let i = 0; i < 6; i++) {
          // 位置在奇數位置的*2，偶數位置*1，計算前6碼
          if (i % 2 === 1) {
            intTmpSum += overTen(parseInt(uniformNo[i]) * 2);
          } else {
            intTmpSum += parseInt(uniformNo[i]);
          }
        }
        const seventhNum = overTen(parseInt(uniformNo[6]) * 4);
        intTmpSum += parseInt(uniformNo[7]); // 第8碼*1

        if ((intTmpSum + seventhNum) % 10 === 0) {
          // 除以 10 後餘 0 表示正確，反之則錯誤
          return true;
        } else if (
          uniformNo[6] === '7' &&
          (intTmpSum % 10 === 0 || (intTmpSum + 1) % 10 === 0)
        ) {
          // 倘若第7碼為7，則第7碼以0或1來加總除10餘0也是正確的
          // *7是唯一一個乘以4後十位數跟個位數相加後不是個位數的(2+8=10)，所以可以是10或是1+0=1，而10可以被10整除，所以可以視為0(總值加10或0結果不變)
          return true;
        }
      }
      return false;
    },
    checkExpiryStatus(v) {
      const digits = (v || '').replace(/\D/g, '');
      
      // 1. 必填檢查
      if (!digits) return { valid: false, msg: '請輸入有效日期' };
      
      // 2. 長度檢查
      if (digits.length !== 4) return { valid: false, msg: '日期格式不完整' };

      const mm = parseInt(digits.substring(0, 2), 10);
      const yy = parseInt("20" + digits.substring(2, 4), 10);

      // 3. 邏輯檢查(例如：9925)
      if (mm < 1 || mm > 12) return { valid: false, msg: '月份無效' };
      
      const now = new Date();
      const expiryDate = new Date(yy, mm, 0, 23, 59, 59);
      if (expiryDate < now) return { valid: false, msg: '信用卡已過期' };

      return { valid: true, msg: '' };
    },
    formatPem(keyContent) {
      // 將 64 個字元切一段，符合 PEM 標準
      const body = keyContent.match(/.{1,64}/g).join('\n');
      return `-----BEGIN PUBLIC KEY-----\n${body}\n-----END PUBLIC KEY-----`;
    },
    //加密
    async encryptToJWE(cardData) {
      // 驗證必要設定參數
      const rawKey = (process.env.VUE_APP_PUBLIC_KEY || '').replace(/\s+/g, '');
      if (!rawKey) {
        this.msg('驗證失敗，請重試');
        return;
      }
      // 組裝成標準 PEM 格式 (JOSE庫需要的)
      const formattedKey = this.formatPem(rawKey);
      try {
        // 1. 依照演算法規格 (config.alg) 將 PEM 格式的公鑰字串轉換為加密物件
        const importedPublicKey = await importSPKI(formattedKey, 'RSA-OAEP-256');
        
        // 2. 建立加密器並執行加密
        const jwe = await new CompactEncrypt(new TextEncoder().encode(JSON.stringify(cardData)))
          .setProtectedHeader({
            alg: 'RSA-OAEP-256', // 加密演算法 (Key Encryption Algorithm)，用於加密「加密金鑰」
            enc: 'A256GCM', // 資料加密方法 (Content Encryption Algorithm)，用於加密「實際數據」
          })
          .encrypt(importedPublicKey);
        return jwe;

      } catch (error) {
        this.msg('驗證失敗，請重試');
        return false;
      }
    },
    async goPayment(Item, Key) {
      if (Item.SelectedPayMethod == null) {
        this.msg('請選擇付款方式');
        return false;
      }
      //支付流程判定，若富邦信用，開啟對話框讓使用者填寫卡號相關資料
      if (Item.SelectedPayMethod.PayMethod_PayMode == 63 && !this.isDataComplete) {
        // 鎖定當前操作的月租帳單，確保彈窗流程完成後能正確執行後續邏輯
        this.currentProcessingItem = Item;//存入該筆帳單資料
        this.currentProcessingKey = Key; // 存入該筆在列表中的索引位置
        this.dialogFubonCard = true;  // 彈出視窗請使用者輸入富邦信用卡資訊
        return;
      }
      
      let jwe = null;
      //僅在富邦信用卡(63)，才須執行加密(僅由 submitFubonCard() 觸發)
      if (Item.SelectedPayMethod.PayMethod_PayMode == 63) {
        const cardData = {
          CardNo: (this.setFubonCardModel.cardNo || '').replace(/\D/g, ''),
          ExpireDate: (this.setFubonCardModel.expiryDate || '').replace(/\D/g, ''),
          Cvv2: (this.setFubonCardModel.CVV || '').replace(/\D/g, ''),
          TransMode: 0,
          InputTime: new Date().toISOString()
        };
        jwe = await this.encryptToJWE(cardData);
        if(!jwe) return; // 加密失敗即停止
      }

      this.request_CreateOrder = {
        RentPay_RentInfoCode: Item.RentPay_RentInfoCode,
        RentPay_RentSetCode: Item.RentPay_RentSetCode,
        RentPay_SRPCode: Item.RentPay_SRPCode,
        PayMethod_PayMode: Item.SelectedPayMethod.PayMethod_PayMode,
        PayMethod_MachineSetNo: Item.SelectedPayMethod.PayMethod_MachineSetNo,
        Model_FrontURL:
          location.protocol + '//' + location.host + location.pathname,
        EncryptedPayload: (Item.SelectedPayMethod.PayMethod_PayMode == 63) ? jwe : null
      };

      this.dbio('/RentPay/CreateOrder', this.request_CreateOrder, 'post').then(
        (response) => {
          switch (Item.SelectedPayMethod.PayMethod_PayMode) {
            case 31:
              if (response.AutoWithhold_Payment == Item.RentPay_Amount) {
                this.dialogBarCode = true;
                this.autoWithhold = response;
                this.autoWithhold.SiteName = Item.RentPay_SiteName;
                this.autoWithhold.RentDateRange = Item.RentPay_RentDateRange;
                this.autoWithhold.SeqNo = Key + 1;
                Item.btnColor = 'success';
              } else {
                this.msg(
                  '目前設定租約與條碼金額不符，請洽該場地管理人員確認。',
                  3000
                );
              }
              break;
            case 52:
            case 60:
            case 62:
            case 63:
              if (this.isMobile()) {
                window.location.href = response.App;
              } else {
                window.location.href = response.Web;
              }
              Item.btnColor = 'success';
              break;  
          }
        })
        .finally(() => {
          //不論成功失敗，皆重置彈窗狀態並清除敏感資料
          if (Item?.SelectedPayMethod?.PayMethod_PayMode == 63) {
            this.handleCloseDialog();
          }
      })
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //安全碼
    validateCVV(v) {
      // 當彈窗關閉觸發重置時，會連帶清空 input 導致觸發此事件。
      // 透過提前返回避免不必要的邏輯執行與潛在的無限迴圈。
      if (!v) return;
      // 移除所有非數字字元
      const cleanValue = v.replace(/\D/g, '');
      
      // 強制同步回 model
      this.$nextTick(() => {
        this.setFubonCardModel.CVV = cleanValue;
      });
    },
    //信用卡號
    formatCardNumber(v) {
      if (!v) return;
      // 1. 先移除所有非數字字元
      let val = v.replace(/\D/g, '');
      
      // 2. 限制最大長度
      val = val.substring(0, 16);
      
      // 3. 格式化
      let groups = val.match(/.{1,4}/g);
      let formatted = groups ? groups.join(' ') : val;

      // 4. 強制同步回 Model
      this.$nextTick(() => {
        this.setFubonCardModel.cardNo = formatted;
      });
    },
    /**
     * 效期輸入輔助邏輯 (自動補0與加斜線)
     * 1. 自動補0：當首碼輸入 > 1 時，自動補 0 (如輸入 2 變 02)，加速輸入。
     * 2. 自動斜線：滿 2 碼後自動插入 /，方便 MM/YY 格式成形。
     * 3. 刪除邏輯：處理 Backspace 碰到斜線時的行為，避免陷入死循環。
     * ※ 搭配 Blur 驗證機制，確保輸入流暢且最終資料合規。
     */
    formatExpiry(v) {
      if (!v) return;
      // 移除所有非數字字元，僅保留純數字串
      let val = v.replace(/\D/g, '');
      // 判斷當前是否為「刪除」動作（當前長度小於上次紀錄長度）
      const isDeleting = v.length < this.prevExpiryLen;

      // 處理刪除邏輯：若在有斜線的狀態下進行刪除，則直接清空以利重新輸入
      if (isDeleting && v.length <= 4 && v.includes('/')) {
        this.$nextTick(() => {
          this.setFubonCardModel.expiryDate = '';
          this.prevExpiryLen = 0;
        });
        return;
      }

      // 自動補零邏輯：若首位數字 > 1 (如輸入 2~9)，自動判定為月份並補 0 (變為 02~09)
      if (!isDeleting && val.length > 0) {
        const firstDigit = parseInt(val.charAt(0));
        if (firstDigit >= 2 && firstDigit <= 9) {
          val = '0' + val;
        }
      }

      let finalVal = '';
      // 格式化顯示：將純數字轉為 "MM / YY" 格式
      if (val.length >= 2) {
        const month = val.substring(0, 2);
        const year = val.substring(2, 4);
        finalVal = month + (val.length > 2 ? ' / ' + year : ' / ');
      } else {
        finalVal = val;
      }

      this.$nextTick(() => {
        // 更新 Model 資料與紀錄長度
        this.setFubonCardModel.expiryDate = finalVal;
        this.prevExpiryLen = finalVal.length;

        const digitCount = val.length; 
        // 當填滿四碼 (MMYY) 時，手動強迫 Vuetify 跑一次上面那個 rules
        if (digitCount === 4) {
          this.$refs.expiryInput?.validate();
        }
      });
    },
    //關掉信用卡填寫對話框
    handleCloseDialog() {
      this.isResetting = true; // 上鎖：告訴所有 Computed 屬性，現在正在清資料別亂動！
      this.dialogFubonCard = false;
      
      // 1. 重置驗證狀態 (如果有找到 ref 才會執行)
      this.$refs.isFubonFormValid?.reset();
      
      // 2. 直接清空資料模型 (這是最保險的，不管 ref 在不在都能跑)
      this.setFubonCardModel = {
        cardNo: '',
        expiryDate: '',
        CVV: ''
      };
      
      // 3. 重置紀錄長度的變數 (如果你有用到 prevExpiryLen)
      this.prevExpiryLen = 0;
      // 清理完畢後，釋放鎖
      this.$nextTick(() => {
          this.isResetting = false;
      });
    },
    submitFubonCard() {
      this.dialogFubonCard = false;
      // 異步處理 (用 $nextTick 確保彈窗關閉狀態已更新，且資料已同步)
      this.$nextTick(() => {
        this.goPayment(this.currentProcessingItem, this.currentProcessingKey);
      });
    },
  }
};
</script>
